export const ODOMETER_OPTIONS = [
  { value: '0 – 10,000', name: '0 Km – 10,000 Km' },
  { value: '10,000 – 20,000', name: '10,000 Km – 20,000 Km' },
  { value: '20,000 – 30,000', name: '20,000 Km – 30,000 Km' },
  { value: '30,000 – 40,000', name: '30,000 Km – 40,000 Km' },
  { value: '40,000 – 50,000', name: '40,000 Km – 50,000 Km' },
  { value: '50,000 – 60,000', name: '50,000 Km – 60,000 Km' },
  { value: '60,000 – 70,000', name: '60,000 Km – 70,000 Km' },
  { value: '70,000 – 80,000', name: '70,000 Km – 80,000 Km' },
  { value: '80,000 – 90,000', name: '80,000 Km – 90,000 Km' },
  { value: '90,000 – 100,000', name: '90,000 Km – 100,000 Km' },
  { value: '100,000 – 110,000', name: '100,000 Km – 110,000 Km' },
  { value: '110,000 – 120,000', name: '110,000 Km – 120,000 Km' },
  { value: '120,000 – 130,000', name: '120,000 Km – 130,000 Km' },
  { value: '130,000 – 140,000', name: '130,000 Km – 140,000 Km' },
  { value: '140,000 – 150,000', name: '140,000 Km – 150,000 Km' },
  { value: '150,000 – 160,000', name: '150,000 Km – 160,000 Km' },
  { value: '160,000 – 170,000', name: '160,000 Km – 170,000 Km' },
  { value: '170,000 – 180,000', name: '170,000 Km – 180,000 Km' },
  { value: '180,000 – 190,000', name: '180,000 Km – 190,000 Km' },
  { value: '190,000 – 200,000', name: '190,000 Km – 200,000 Km' },
  { value: '200,000 – 210,000', name: '200,000 Km – 210,000 Km' },
  { value: '210,000 – 220,000', name: '210,000 Km – 220,000 Km' },
  { value: '220,000 – 230,000', name: '220,000 Km – 230,000 Km' },
  { value: '230,000 – 240,000', name: '230,000 Km – 240,000 Km' },
  { value: '240,000 – 250,000', name: '240,000 Km – 250,000 Km' },
  { value: '250,000+', name: '250,000 Km+' },
];

export const SELL_YOUR_CAR_STEPS = [
  'Tell us about the car?',
  'Fuel Type',
  'Transmission',
  'Odometer reading?',
  'State of vehicle?',
  `Almost done. <br/> Do you want to upload photos of the vehicle?`,
  'How much would you like to sell your car for?',
  'Last question <br> How can we reach you? ',
  'THANK YOU',
] as const;

export const FUEL_TYPES = ['Petrol', 'Diesel', 'Electric', 'Hybrid'];
export const TRANSMISSION_TYPES = ['Manual', 'Automatic'];
export const VEHICLE_STATES = ['Excellent', 'Average', 'Needs Repair'];

export const AVAILABLE_CAR_YEARS = Array.from(new Array(15), (_, index) =>
  (new Date().getFullYear() - index).toString(),
);

export const SELL_YOUR_CAR_MAX_PHOTOS = 20;
